import { promiseWrapper } from '@/helpers';
import { placeService } from '@/services';
import { Place } from '@/types/state/shared';

export async function fetchAndSetPlaceData(
  {
    id,
    slug,
    isMpReviews,
    isSistaminuten,
  }: {
    id: number;
    slug: string;
    isMpReviews: boolean;
    isSistaminuten: boolean;
  },
  setPlace: (place: Place) => void,
  onError: (error: unknown) => void,
  history /** react-router-dom history */,
) {
  const { data, error } = await promiseWrapper(placeService.findPlace(id, slug, isMpReviews, isSistaminuten));

  if (error) {
    onError(error);
    return;
  }

  const { place, redirect, locations, selectedGroup } = data.data;

  if (redirect) {
    return (window.location = redirect);
  }

  place.locations = locations;
  place.groupName = selectedGroup;

  /**
   * Don't have reviews for normal placepage - fetch again to check if was miss in cache
   */
  await (async () => {
    if (place.reviews === null && !Boolean(place.external)) {
      const { data } = await promiseWrapper(placeService.getPlaceReviews(place.id, isMpReviews));

      if (data?.reviews) {
        place.reviews = data.reviews;
      }
    }
  })();

  setPlace(place);

  if (data.redirect) {
    history.replace(data.redirect);
  }
}
